// src/components/filter.
import React, { useEffect, useMemo, useState } from "react";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Col, Card, CardBody, Row, Label } from "reactstrap";
import TableContainer from "components/Common/TableContainer";
import { BCustomerInvoice } from "models/Invoice";
import moment from "moment";
import { InvoiceService } from "services/InvoiceService";
import InvoiceView from "./InvoiceView";
import { OrderResponse } from "models/orderResponse";
import { OrderService } from "services/OrderService";
import { toast } from "react-toastify";
import { PaymentType } from "enum/PaymentOption";
import { format, parseISO } from "date-fns";
import { useAuth } from "context/AuthProvider";
import { CreditCardService } from "services/CreditCardService";
import { useNavigate } from "react-router-dom";
const Invoices: React.FC = () => {
  document.title = "Invoices | Zulu Courier ";
  const [startDate, setStartDate] = useState(moment.tz("America/Toronto").startOf("month"));
  const [endDate, setEndDate] = useState(moment.tz("America/Toronto"));
  const [invoices, setInvoices] = useState([] as BCustomerInvoice[]);
  const [selectedYear, setSelectedYear] = useState<number>(2026);
  const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
  const [availableYears, setAvailableYears] = useState<number[]>([2026]);
  const [showTable, setShowTable] = useState(false);
  const [invoice, setInvoice] = useState<BCustomerInvoice>();
  const [invoiceDate, setInvoiceDate] = useState({
    index: "",
    customerName: "",
    customerId: "",
    totalOrders: 0,
    totalAmount: 0,
    totalhst: 0,
    totalsubTotal: 0,
    discount: 0,
    outstandingBalance: 0,
  });
  const [orders, setOrders] = useState([] as OrderResponse[]);
  const [totalPayment, setTotalPayment] = useState(0);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);

  const [LIMIT_P_C] = useState<number>(10);
  const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(1);
  const [modal, setModal] = useState(false);
  const [user] = useAuth();
  const data = {
    startDate: startDate,
    endDate: endDate,
  };
  const navigate = useNavigate();

  useEffect(() => {
    getCustomerInvoice();
    fetchAvailableYears();
  }, []);

  const fetchAvailableYears = async () => {
    try {
      const res = await InvoiceService.getAvailableInvoiceYears();
      if (res.success && res.data.length > 0) {
        setAvailableYears(res.data);
      }
    } catch (error) {
      console.error("Error fetching available years:", error);
    }
  };

  useEffect(() => {
    setOffset_p_c(1);
    getCustomerInvoice();
  }, [selectedYear, selectedMonth]);
  useEffect(() => {
    getTotalPayment(invoices); // Initialize total amount
  }, []);

  useEffect(() => {
    getTotalPayment(invoices, selectedInvoices);
  }, [selectedInvoices, invoices]);

  const handlePayment = async (values: any) => {
    try {
      const orderId = values.original._id;
      if (!user?.email) {
        throw new Error("User email is required");
      }

      const outstandingBalance = values.original.isAdminUpdated
        ? values.original.outstandingBalance - (values.original.discount || 0)
        : values.original.totalAmount;
      const orderIdList = [orderId];
      const totalFare = outstandingBalance
      const paymentType = PaymentType.INVOICE;
      if (orderId) {
        navigate(`/${user?.role}/payment-card`, {
          state: { orderIdList, paymentType, totalFare },
        });
      } else {
        console.error("Order ID not found.");
      }
    } catch (error) {
      console.error("Order create error", error);
    }
  };

  const handleSelectInvoice = async () => {
    if (selectedInvoices.length <= 0) {
      return toast.error("Invoices not selected", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
    if (!user?.email) {
      throw new Error("User email is required");
    }

    const totalFare = totalPayment.toFixed(2);

    navigate(`/${user?.role}/payment-card`, {
      state: {
        orderIdList: selectedInvoices,
        paymentType: PaymentType.INVOICE,
        totalFare
      },
    });
  };

  const getCustomerInvoice = async () => {
    await InvoiceService.getBusinessCustomerInvoices(LIMIT_P_C, isOffset_p_c, selectedYear, selectedMonth)
      .then(res => {
        if (res.success) {
          setInvoices(res.data.userInvoices);
          setShowTable(true);
          getTotalPayment(res.data.userInvoices);
          setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const SeeMore = (page: any) => {
    setOffset_p_c(page.selected + 1);
    InvoiceService.getBusinessCustomerInvoices(LIMIT_P_C, page.selected + 1, selectedYear, selectedMonth)
      .then(res => {
        if (res.success) {
          setInvoices(res.data.userInvoices);
          setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const getTotalPayment = (data: BCustomerInvoice[], selectedInvoices: string[] = []) => {
    const invoicesToCalculate = selectedInvoices.length > 0
      ? data.filter((invoice) => invoice._id && selectedInvoices.includes(invoice._id))
      : data;

    const calculatedTotalPayment = invoicesToCalculate.reduce((sum, invoice) => {
      if (invoice.paymentStatus !== "paid") {
        const discount = invoice.discount ?? 0;
        const outstandingBalance = invoice.outstandingBalance ?? 0;
        const amountToAdd = invoice.isAdminUpdated ? outstandingBalance - discount : invoice.totalAmount ?? 0;

        return sum + (amountToAdd ?? 0);
      }
      return sum;
    }, 0);

    const roundedTotalPayment = calculatedTotalPayment.toFixed(2);
    const roundedTotalPaymentNumber = parseFloat(roundedTotalPayment);
    setTotalPayment(roundedTotalPaymentNumber);
  };

  const handlePopup = () => {
    setModal(!modal);
  };

  const handleSelectedInvoices = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
    const isSelected = event.target.checked;

    setSelectedInvoices((prevSelectedInvoices) => {
      const updatedSelectedInvoices = isSelected
        ? [...prevSelectedInvoices, id]
        : prevSelectedInvoices.filter((selectedId) => selectedId !== id);

      return updatedSelectedInvoices;
    });
  };

  const PaySelectedInvoicesHandler = () => {
    if (selectedInvoices.length <= 0) {
      return toast.error("Invoices not selected", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
    OrderService.createStripeSession({ orderIdList: selectedInvoices, paymentType: PaymentType.INVOICE })
      .then(res => {
        if (res.success) {
          window.open(res.data, '_blank');
        } else {
          return toast.error(res.error, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: { marginBottom: "4rem" },
          });
        }
      })
      .catch(err => {
        console.error(err.message);
      });
  };

  const handleViewInvoice = (values: any) => {
    InvoiceService.getBcustomerInvoiceById(values.original?._id).then(res => {
      if (res.success) {
        setInvoice(res.data);
      }
    });

    setInvoiceDate({
      index: values.index,
      customerName: values.original?.firstName + " " + values.original?.lastName,
      totalOrders: values.original?.totalOrders,
      totalAmount: values.original?.totalAmount,
      customerId: values.original?.customerId,
      totalhst: values.original?.totalhst,
      totalsubTotal: values.original?.totalsubTotal,
      discount: values.original?.discount,
      outstandingBalance: values.original?.outstandingBalance,
    });

    values.original?.orders.map((order: any) => {
      setOrders(order);
    });
    handlePopup();
  };

  const searchTable = (searchText: string) => {
    const searchdata = {
      searchableString: searchText,
    };

    InvoiceService.getBusinessCustomerInvoicesBySearch(searchdata, selectedYear, selectedMonth).then(res => {
      if (res.success) {
        if (res?.data?.userInvoices?.length !== 0) {
          setInvoices(res.data.userInvoices);
        }
      }
    });
  };

  const months = [
    { value: null, label: "All Months" },
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const columns = useMemo(
    () => [
      {
        id: "select",
        Header: "",
        Cell: ({ row }: any) => {
          return (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                name={row.original._id}
                checked={selectedInvoices.includes(row.original._id)}
                disabled={row.original.paymentStatus === "paid"}
                onChange={(event) => handleSelectedInvoices(row.original._id, event)}
              />
            </div>
          );
        },
      },
      {
        id: "invoiceId",
        Header: "Invoice Number",
        accessor: "invoiceId",
        Cell: ({ row }: any) => {
          return row.original.invoiceId;
        },
        disableSortBy: true,
        indexed: true,
      },
      {
        id: "date",
        Header: "Billing Period",
        accessor: "date",
        Cell: ({ row }: any) => {

          const createdAtString = row.original.createdAt;

          const startOfMonth = moment(createdAtString).startOf('month').format();
          const endOfMonth = moment(createdAtString).endOf('month').format();

          const createdDate = format(parseISO(startOfMonth), "MMM do");
          const updatedDate = format(parseISO(endOfMonth), "MMM do");

          return `${createdDate} - ${updatedDate}`;
        },
      },
      // {
      //   id: "totalOrders",
      //   Header: "Total Number of Orders",
      //   accessor: "totalOrders",
      // },
      {
        id: "totalAmount",
        Header: "Amount",
        accessor: "totalAmount",
        Cell: ({ row }: any) => {
          const amount = row.original.isAdminUpdated ? (row.original.outstandingBalance ?? 0) - (row.original.discount ?? 0) : row.original.totalAmount;
          return `$${amount.toFixed(2)}`;
        },
      },
      {
        id: "action",
        Header: "",
        Cell: ({ row }: any) => {
          return (
            <div className="text-center">
              <button className="btn btn-sm btn btn-outline-primary" onClick={() => handleViewInvoice(row)}>
                View
              </button>
              {row.original.paymentStatus === "paid" ? (
                <button className="btn btn-sm btn btn-primary m-2 disabled">
                  Paid
                </button>
              ) : (
                <button className="btn btn-sm btn btn-primary m-2" onClick={() => handlePayment(row)}>
                  Pay
                </button>
              )}
            </div>
          );
        },
      },
    ],
    [selectedInvoices]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Invoice" breadcrumbItem="All Invoices" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center mb-2 w-md-50 justify-content-between ">
                      <p className="m-0 me-2">
                        Total Amount Due: <span className="fw-semibold">$ {totalPayment.toFixed(2)}</span>
                      </p>
                      <button onClick={handleSelectInvoice} className="btn btn-sm btn-primary mx-2">
                        Pay All Selected Invoices
                      </button>
                    </div>
                  </div>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Label>Year</Label>
                      <select
                        className="form-select form-select-sm"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                      >
                        {availableYears.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col md={3}>
                      <Label>Month</Label>
                      <select
                        className="form-select form-select-sm"
                        value={selectedMonth ?? "null"}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedMonth(val === "null" ? null : Number(val));
                        }}
                      >
                        {months.map((month) => (
                          <option key={month.label} value={month.value ?? "null"}>
                            {month.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  </Row>
                  {showTable && (
                    <div className="wizard clearfix">
                      <Label>Billing Table</Label>
                      <Row>
                        <Col lg="12">
                          {invoices.length > 0 ? (
                            <TableContainer
                              columns={columns}
                              data={invoices}
                              currentPage={undefined}
                              pagelimit={pageCount}
                              handlePageChange={SeeMore}
                              handleColumnChange={undefined}
                              selectedColumns={undefined}
                              showColumnChange={false}
                              handleSearch={searchTable}
                              isGlobalFilter={true}
                              isAddOptions={false}
                              customPageSize={10}
                              className="custom-header-css"
                              isJobListGlobalFilter={undefined}
                              isAddUserList={undefined}
                              handleOrderClicks={undefined}
                              handleUserClick={undefined}
                              handleCustomerClick={undefined}
                              isAddCustList={undefined}
                              handleSendEmail={undefined}
                              isPDFGenerate={false}
                              isAddressBook={false}
                              ispopup={false}
                              hancleDeleteRecords={undefined}
                              handleSelect={undefined}
                              selectedID={undefined}
                              hasCheckBox={false} footerData={undefined} />
                          ) : (
                            <Row className="justify-content-md-center justify-content-center align-items-center">
                              <Col className="col-md-auto">
                                <div style={{ height: "100px" }}>No Billings</div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <InvoiceView isOpen={modal} handlePopup={handlePopup} invoice={invoice} invoiceDate={invoiceDate} orders={orders} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Invoices;
